export default function (props: any) {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M34.9905 31.8192C35.6753 30.1688 36.0535 28.3615 36.0535 26.467V10.7382L21.6819 6.10938L7.31152 10.7382V26.467C7.21942 38.6715 22.2985 45.1044 31.2752 37.0058"
                stroke="#FFBD3C"
                strokeWidth="2.875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.6727 16.5915C23.3514 14.2575 19.8665 13.8111 17.0972 15.2481L20.0204 18.1872L16.8541 21.3708L13.9309 18.4317C12.5017 21.215 12.9467 24.7199 15.267 27.0539C17.4491 29.2469 20.6586 29.7712 23.3357 28.6328L32.566 37.9144C33.6453 38.9996 35.3951 38.9986 36.4744 37.9144C37.5537 36.8292 37.5537 35.0699 36.4744 33.9847L27.2441 24.7041C28.3753 22.0124 27.8548 18.7855 25.6727 16.5915Z"
                stroke="#FFBD3C"
                strokeWidth="2.875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
